import { UniverseUIConfiguration } from '@tacans/shared-marketplace-layer';
import { useMemo } from 'react';
import { useUniverseConfigurationsContext } from 'src/features/common/universe/hooks/use-universe-configurations-context';

export const useUniverseConfigurations = (): UniverseUIConfiguration[] => {
    const { configurations = [] } = useUniverseConfigurationsContext();

    return useMemo(
        () =>
            configurations.map((config) => ({
                ...config,
                value: config.value ? JSON.parse(config.value) : {},
            })),
        [configurations]
    );
};
